<template >
<div class="container-fluid">  
  <BarreFiltres :filtres="filtres" @appliquer-filtre="appliquerFiltre($event)" />  
  <div class="flex-center-center">
    <div class="card col-12 col-xl-10 col-xxl-8 height-responsive">
      <div class="card-header" >
        Productions - Documentation
      </div>

      <div class="card-container height-responsive-body height-responsive-1b">
        <div class="card-body">
          <p>Une production permet de générer 3 documents principaux utiles pour la mise en production des recettes, la gestion du stock et la livraison des recettes si besoin.<br/>
            <ul class="puces">
              <li><b>Fiche de production</b> : indique pour chaque recette les quantités d'ingrédients nécessaires pour le nombre d'effectifs paramétré sur le menu. En fonction du paramétrage du barquettage et du portage, ce fichier indique également la quantité de barquette à prévoir pour la recette.</li>
              <li><b>Fiche de sortie</b> : indique la quantité d'ingrédient à sortir de votre stock pour la production des recettes.</li>
              <li><b>Bon de livraison</b> : indique les recettes à livrer sur vos lieux de portage, indique également la quantité de barquettes à livrer en fonction du paramétrage.</li>
            </ul>
          </p>
          <p>Elle génère également d'autres documents :
            <ul class="puces">
              <li><b>Sortie de production</b> : indique les quantités de produits à sortir du stock.</li>
              <li><b>Relevé de température</b> : pour suivre les températures de chaque recette.</li>
              <li><b>Refroidissement</b> : pour suivre l'étape de refroidissement de chaque recette.</li>
              <li><b>Etiquettes</b> : pages d'étiquettes au format 99.1 x 38.1 mm, 14 étiquettes par page, pour étiquetter les barquettes de portages.</li>
              <li><b>Récapitulatif d'allotissement</b> : indique pour chaque recette le nombre d'effectifs par lieu de portage</li>
            </ul>
          </p>
        </div>

        <section id="sectionConfiguration">
          <div class="header header-tertiary">Configuration des productions</div>
          <div class="card-body">
            <div class="container mb-3">
              <img class="border-black border-rounded w-100" src="../../assets/images/documentation/production/configuration/configurationProduction.png" alt="Configuration production">
            </div>
            <p>Sur cette page vous pouvez définir des informations et options pour les fichiers générés pour vos producitons.</p>
            <ul class="puces">
              <li>Agrément Sanitaire : nécessaire pour effectuer du portage</li>
              <li>DLC : nombre de jours limite de consommation après la production</li>
              <li>Répartition par lieu de portage : indique sur la fiche de production le nombre d'effectifs par lieu de portage pour chaque recette. Soit en fin de fichier, soit sous chaque recette.</li>
              <li>Bons de livraison : options pour le fichier bon de livraison</li>
              <li>Etiquettes : indique si le fichier des étiquettes doit etre généré. Si les barquettes sont configurées, il génère une étiquette par barquette, avec le nombre de portions de chaque recette. Sinon on indique le nombre d'effectifs par recette.</li>
              <li>Enregistrement du refroidissement : pour personnaliser le fichier de suivi de refroidissement.</li>
            </ul>
          </div>
        </section>

        <section id="sectionProduction">
          <div class="header header-tertiary">Création d'une production</div>
          <div class="card-body">
            <p>Pour lancer une production, cliquez sur "Créer une mise en production".</p>
            <div class="container mb-3">
              <img class="border-black border-rounded w-100" src="../../assets/images/documentation/production/suivi/creationProduction1.png" alt="Illustration page production">
            </div>
            <p>Si vous sélectionnez une période qui dispose d'un menu, celui-ci s'intégrera directement dans le champ 'structure de menus à inclure'. Vous avez ensuite la possibilité d'indiquer les services concernés.</p>
            <div class="container mb-3">
              <img class="border-black border-rounded w-100" src="../../assets/images/documentation/production/suivi/creationProduction2.png" alt="Illustration page production">
            </div>
            <p>Quand vous cliquez sur "créer", une fenêtre s'affiche pour que vous puissiez attribuer un nom à votre production ainsi qu'une DLC. </p>
            <div class="flex-center-center mb-3">
              <div class="col-8">
                <img class="border-black border-rounded w-100" src="../../assets/images/documentation/production/suivi/fenetreCreationProduction.png" alt="Illustration page production">
              </div>
            </div>
            <p>Elle sera répertoriée dans "Productions en cours". Cliquez dessus pour accéder à des options supplémentaires et suivez les étapes indiquées.</p>
            <div class="container mb-3">
              <img class="border-black border-rounded w-100" src="../../assets/images/documentation/production/suivi/etapeMiseEnProd.png" alt="Illustration des étapes pour la mise en production">
            </div>
            <p>Lorsque vous atteignez l'étape numéro 2, vous avez toujours la possibilité d'ajuster les effectifs en accédant à "Menus - Suivi". Une fois que vous avez saisi les nouveaux effectifs, effectuez le recalcul des documents pour les mettre à jour. </p>
            <p>Vous pouvez choisir parmi différentes options d'exportation, soit en format PDF ou en Excel.</p> 
            <p>Si vous cliquez sur confirmer la sortie de stock, un message vous demande confirmation de la sortie de stock, correspondant à votre production</p>           
          </div>
        </section>

        <section id="sectionSupression">
          <div class="header header-tertiary">Suppression d'une production</div>
          <div class="card-body">          
            <p>Une fois créée, vous pouvez supprimer une production. Pour cela, reportez-vous à la liste des productions en cours, cliquez sur celle que vous souhaitez supprimer.</p>
            <p>En bas de l'écran un champ s'affiche avec sur la gauche un bouton supprimer.</p>
            <div class="container mb-3">
              <img class="border-black border-rounded w-100" src="../../assets/images/documentation/production/suivi/suppressionProduction.png" alt="Illustration supression production">
            </div>
          </div>
        </section>
                
        <section id="sectionPortage">
          <div class="header header-tertiary">Gestion de vos lieux de portage</div>
          <div class="card-body">
            <p>
              Ici, vous pouvez gérer pour votre établissement des lieux de portages, sur lesquels vos productions peuvent être livrées.<br/>
              Pour chacun des lieux de portage vous devez définir un effectif par défaut pour chaque structure / service de menu, ainsi que ses jours d'ouvertures.<br/>
              La liste présente de façon synthétique les jours d'ouvertures et le nombre d'effectifs total à livrer sur le lieu de portage.<br/>
              Il est possible d'afficher le détail des effectifs par structure/régime/texture en cochant la case "Détailler les catégories".<br/>
            </p>
            <div class="container mb-3">
              <img class="border-black border-rounded w-100" src="../../assets/images/documentation/production/portage/listePortage.png" alt="Illustration liste lieu de portage">
            </div>
            <p>
              La liste des lieux de portage peut etre triée à partir du bouton <button class="btn btn-primary">Trier les lieux de portage</button>. Il suffit de glisser déposer les lieux en fonction de l'ordre voulu.<br/>
              Les jours d'ouvertures peuvent etre modifiés de facon générale à partir du bouton <button class="btn btn-primary">Modifier les jours d'ouvertures</button>.<br/>
            </p>
          </div>
        </section>

        <section id="sectionCreationPortage">
          <div class="header header-tertiary">Paramétrage du lieu de portage</div>
          <div class="card-body">
            <p>
              Pour créer un nouveau lieu de portage, il suffit de cliquer sur le bouton <button class="btn btn-primary">Ajouter un lieu</button>
            </p>
            <div class="container mb-3">
              <img class="border-black border-rounded w-50" src="../../assets/images/documentation/production/portage/creationPortage.png" alt="Illustration création portage">
            </div>
            <p>
              Il faut renseigner les informations du lieu de portage, son nom, son adresse ainsi que ses jours d'ouvertures.<br/>
              Le nombre d'effectifs à livrer doit être défini pour chaque structure / service / régime et texture.<br/>
              L'option "Plat témoin" permet d'ajouter un effectif au total du lieu du portage.<br/><br/>
              Il est possible de définir les barquettes utilisables pour le portage des recettes :<br/>
              <ul>
                <li>
                  De facon générale sur le lieu de portage, on peut définir les barquettes qui seront utilisées pour calculer le portage pour l'ensemble des structures / régimes et textures.
                </li>
                <li>
                  Ou alors sur chaque structure, cette configuration sera utilisée en prioritée si existante.
                </li>
              </ul>
              Si aucune configuration de barquette n'est choisie sur le lieu ou sur les structures du lieu, ce sera la configuration définie sur la structure de menu qui sera utilisée pour calculer le nombre de barquettes.<br/><br/>
              L'option "Séparation du BL" permet de séparer par régime et texture le nombre d'effectifs sur chaque recette dans le bon de livraison.<br/><br/>
              Il est possible de rendre le lieu de portage "inactif", il ne sera donc pas pris en compte dans les calculs de livraisons.
            </p>
            <p>
              La modification d'un lieu de portage se fait via la même fenêtre, à partir du bouton <button class="btn btn-primary">Ouvrir</button>
            </p>
          </div>
        </section>

        <section id="sectionBarquettage">
          <div class="header header-tertiary">Gestion des barquettes</div>
          <div class="card-body">
            <p>
              Ici, Vous pouvez gérer pour votre établissement les barquettes que vous utilisez.<br/>
              Une barquette est définie par sa désignation et le nombre de portion qu'elle peut contenir.<br/>
            </p>
            <div class="container mb-3">
              <img class="border-black border-rounded w-100" src="../../assets/images/documentation/production/barquettage/listeBarquette.png" alt="Illustration liste barquette">
            </div>
          </div>
        </section>

        <section id="sectionCreationBarquette">
          <div class="header header-tertiary">Ajout/Modification d'une barquette</div>
          <div class="card-body">
            <p>
              Pour créer une nouvelle barquette, il suffit de cliquer sur le bouton <button class="btn btn-primary">Ajouter une barquette</button><br/>
              Toutes les barquettes actives de cette liste seront visibles sur les pages Structures de menu et lieu de portage.
            </p>
            <div class="container mb-3">
              <img class="border-black border-rounded w-50" src="../../assets/images/documentation/production/barquettage/creationBarquette.png" alt="Illustration création barquette">
            </div>
            <p>
              Il faut renseigner la désignation ainsi que le nombre de portions de la barquette.<br/>
              Il est possible de rendre une barquette inactive, dans ce cas elle ne sera pas prise en compte dans les calculs de production/livraison.<br/>
            </p>
            <p>
              La modification d'une barquette se fait via la même fenêtre, à partir du bouton <button class="btn btn-primary">Ouvrir</button>
            </p>
          </div>
        </section>

        <section id="sectionArchive" >
          <div class="header header-tertiary">Archive</div>
          <div class="card-body">
            <p>Une fois votre production réalisée, utilisez le bouton numéro 3 pour archiver votre production.</p>
            <p>Dans le menu "Production", vous avez la possibilité de consulter vos productions clôturées dans le sous-menu "Archive"</p> 
            <div class="container mb-3">
              <img class="border-black border-rounded w-100" src="../../assets/images/documentation/production/archive/archiveProduction.png" alt="Illustration archive production">
            </div>
            <p>Vous pouvez également télécharger les documents suivants :</p>
            <ul class="puces">
              <li>La fiche de production</li>
              <li>La fiche de sortie</li>
              <li>Le bon de livraison</li>
            </ul>
          </div> 
        </section>  
      </div>
    </div>     
  </div>
</div>
</template>

<script>
import BarreFiltres from '@/components/Divers/BarreFiltres'

export default {
  name: "DocProductions",
   components: {
    BarreFiltres
  },
  data() {
    return {
      filtres: {
        sections: {
          label: "Choix de votre recherche...",
          champ: "select",
          options: [
            {valeur: 'sectionProduction', texte: `Suivi: Création d'une production`},
            {valeur: 'sectionSupression', texte: `Suivi: Supression d'une production`},  
            {valeur: 'sectionPortage', texte: `Portage: Gestion des lieux de portage`},  
            {valeur: 'sectionBarquettage', texte: `Barquettage: Gestion des barquettes`},  
            {valeur: 'sectionArchive', texte: `Archive`},           
          ],
          selection: [],
          filtrer(contexte) {
            let filtre = contexte.filtres.sections
            if (filtre.selection) {
              let sectionSelectionnee = document.getElementById(filtre.selection.valeur);
              if (sectionSelectionnee) {
                sectionSelectionnee.scrollIntoView();
              }  
            }
            
          }
        },
        // Appeler "this.filtres.initialiser(this)" dans mounted() => génère le tableau de filtres utilisés pour afficher les filtres dans la barre de filtres
        barreGauche: [],
        barreDroite: [],
        initialiser(contexte) {
          contexte.filtres.barreGauche = [ contexte.filtres.sections ]
        }
      },      
    }
  }, 
 methods: {
    appliquerFiltre(filtrer) {
      // Nécessaire pour faire fonctionner les filtres de la barre de filtres
      filtrer(this)
    },
  },
  mounted() {
    this.filtres.initialiser(this)
  }
}
</script>
